import React from 'react';
import { Grid, Stack } from '@mui/material';
import MaterialTypography from '../../../../components/MaterialTypography';
import MaterialInput from '../../../../components/MaterialInput';

const TestEnvironment = ({ formData, handleChange }) => {
    return (
        <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                <Stack spacing={1}>
                    <MaterialTypography variant="caption" fontWeight="bold">Web Environment</MaterialTypography>
                    <MaterialInput size="small" name="webEnvironment" value={formData.webEnvironment} onChange={handleChange} placeholder="Enter Web Environment" fullWidth />
                </Stack>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                <Stack spacing={1}>
                    <MaterialTypography variant="caption" fontWeight="bold">Mobile App</MaterialTypography>
                    <MaterialInput size="small" name="mobileApp" value={formData.mobileApp} onChange={handleChange} placeholder="Enter Mobile App" fullWidth />
                </Stack>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                <Stack spacing={1}>
                    <MaterialTypography variant="caption" fontWeight="bold">Browsers Tested</MaterialTypography>
                    <MaterialInput size="small" name="browsersTested" value={formData.browsersTested} onChange={handleChange} placeholder="Enter Browsers Tested" fullWidth />
                </Stack>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                <Stack spacing={1}>
                    <MaterialTypography variant="caption" fontWeight="bold">Database</MaterialTypography>
                    <MaterialInput size="small" name="database" value={formData.database} onChange={handleChange} placeholder="Enter Database" fullWidth />
                </Stack>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                <Stack spacing={1}>
                    <MaterialTypography variant="caption" fontWeight="bold">Server</MaterialTypography>
                    <MaterialInput size="small" name="server" value={formData.server} onChange={handleChange} placeholder="Enter Server" fullWidth />
                </Stack>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                <Stack spacing={1}>
                    <MaterialTypography variant="caption" fontWeight="bold">Test Device</MaterialTypography>
                    <MaterialInput size="small" name="testDevice" value={formData.testDevice} onChange={handleChange} placeholder="Enter Test Device" fullWidth />
                </Stack>
            </Grid>
        </Grid>
    );
};

export default TestEnvironment;
